"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCSVToJSON = getCSVToJSON;
var _json2Csv = require("json-2-csv");
function getCSVToJSON(_ref) {
  var input = _ref.input,
    _ref$selectedSpaces = _ref.selectedSpaces,
    selectedSpaces = _ref$selectedSpaces === void 0 ? 2 : _ref$selectedSpaces;
  var res = (0, _json2Csv.csv2json)(input);
  return JSON.stringify(res, null, selectedSpaces);
}